<div class="modalRedireccion h-100 pt-lg-4">
  <div class="text-start btn-volver-redireccion d-block d-lg-none">
    <span [mat-dialog-close]="false" role="button" title="Volver" class="material-symbols-outlined primary-900 mat-icon-size-30">arrow_back_ios</span>
  </div>

  @if (data) {
    <div class="container px-0 px-lg-3 intro-linea d-flex align-items-center justify-content-center ">
      <div class="d-block text-center">
        <div class="mat-icon-container">
          <span class="material-symbols-outlined filled mat-icon-size-50 {{data.iconColor ? data.iconColor : 'primary-800'}}">info</span>
        </div>
        <p class="p1-medium text-center my-3 primary-800" [innerHTML]="data.textoDestacado"></p>
        @if (data.textoInformativo && data.textoInformativo !== '') {
          <div
            class="p2-regular text-start bg-primary-800 text-white px-4 px-md-5 py-4 border-radius-6 my-4 mx-lg-4"
            [innerHtml]="data.textoInformativo">
          </div>
        }
        <div class="text-center py-3">
          <button [disabled]="isLoading" class="btn btn-primary w-100 w-lg-auto px-lg-5 mx-auto" title="Aceptar" [mat-dialog-close]="true"
            (click)="isLoading = true">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  }
</div>